import React from 'react';
import propTypes from 'prop-types';
export const EcommerceShopTransactionIcon = ({
  size = 18,
  color = 'black',
}) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      viewBox="0 0 64 64"
      id="icons"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title />
      <path
        fill={color}
        d="M52,7H12a6,6,0,0,0-6,6V51a6,6,0,0,0,6,6H52a6,6,0,0,0,6-6V13A6,6,0,0,0,52,7Zm2,44a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2H52a2,2,0,0,1,2,2Z"
      />
      <path
        fill={color}
        d="M45,29a2,2,0,0,0,0-4H22.83l2.58-2.59a2,2,0,0,0-2.82-2.82l-6,6a2,2,0,0,0-.44,2.18A2,2,0,0,0,18,29Z"
      />
      <path
        fill={color}
        d="M47,36H20a2,2,0,0,0,0,4H42.17l-2.58,2.59a2,2,0,1,0,2.82,2.82l6-6a2,2,0,0,0,.44-2.18A2,2,0,0,0,47,36Z"
      />
    </svg>
  );
};
EcommerceShopTransactionIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
EcommerceShopTransactionIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
